import {
  Button,
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import usePrintingTable from "./usePrintingTable";
import RemarksTable from "../../../Global/RemarksTable";
import { Table } from "../../../Global/Table";
// import Style from "../printing.module.scss";

const PrintingTable = ({
  gliNumber,
  visitingOneFrontPrintRef,
  visitingOneBackPrintRef,
  papperFrontPrintRef,
  papperBackPrintRef,
  bigFrontPrintRef,
  foldableCardRef,
  vistingDuplexRef,
  papperDuplexRef,
}) => {
  const {
    state,
    tableData,
    isLoading,
    tableFields,
    isFetching,
    currentPageSize,
    paginationOptions,
    globalRemarkModal,
    getRow,
    handleSearch,
    handlePageSize,
    handlePagination,
    handlePrintClick,
    handleModalClose,
    loading,
    previousPrintLoading,
    handlePreviousPrint,
    printLimitError,
    previewState,
    handleConfirmPrint,
    handleCancelPreview,
  } = usePrintingTable({
    visitingOneFrontPrintRef,
    visitingOneBackPrintRef,
    papperFrontPrintRef,
    papperBackPrintRef,
    bigFrontPrintRef,
    foldableCardRef,
    vistingDuplexRef,
    papperDuplexRef,
  });
  return (
    <div>
      {state?.is_multi_print ? (
        <>
          <h6 className="pro-ttl h6">
            Multi Selected GLI :{" "}
            {state?.gliform?.gli_data?.map((item, index) => (
              <span key={index}>
                {item.gli_number}
                {index < state.gliform.gli_data.length - 1 && ", "}
              </span>
            ))}
          </h6>
        </>
      ) : (
        <h6 className="pro-ttl h6">{gliNumber}</h6>
      )}

      <SearchFilters
        onSearchInput={handleSearch}
        SearchIcon={<span className="material-symbols-outlined"> search </span>}
        showClearFilters={false}
        searchInputProps={{
          value: state?.search,
          placeholder: "Search Certificate Number",
        }}
        showActions={false}
        loading={isLoading}
      />
      {printLimitError && (
        <div className="col-12 pro-mb-2">
          <span className="error-text" style={{ color: "var(--pro-danger)" }}>
            {printLimitError}
          </span>
        </div>
      )}
      <Table
        multiSelect={true}
        data={
          state?.is_multi_print
            ? state?.multipleTableData?.data
            : (tableData?.data?.data ?? [])
        }
        uniqueID={"id"}
        // uniqueID={"id"}
        fields={tableFields}
        SortIcon={<FaSort />}
        assignIcon={<span className="material-symbols-outlined">print</span>}
        getRow={getRow}
        loading={isFetching}
        perpage={currentPageSize}
        assignable={true}
        deletable={false}
        showCheckBox={true}
        editable={true}
        handleAssign={loading ? () => {} : handlePrintClick}
        assignText={loading ? `Printing...` : `Print & Upload`}
        editText={previousPrintLoading ? `Downloading...` : `Download JPG`}
        editIcon={<span className="material-symbols-outlined">print</span>}
        handleEdit={previousPrintLoading ? () => {} : handlePreviousPrint}
        clear={state?.clear}
        // tableWrapClassName={"max-w-max"}
      />
      {!state?.is_multi_print && tableData?.data?.data && (
        <Pagination
          currentPage={parseInt(tableData?.data?.current_page)}
          totalPageCount={Math.ceil(
            tableData?.data?.total_count / tableData?.data?.per_page,
          )}
          defaultValue={paginationOptions?.find(
            (item) => item?.value === state.currentPageSize,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}
      {state?.is_multi_print && state?.multipleTableData && (
        <Pagination
          currentPage={parseInt(state?.multipleTableData.current_page)}
          defaultValue={paginationOptions?.find(
            (item) => item?.value === state.currentPageSize,
          )}
          totalPageCount={Math.ceil(
            state?.multipleTableData.total_count /
              state?.multipleTableData.per_page,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{ root: "pro-modal-xxl" }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTable />
        </div>
      </ModalLayout>

      <ModalLayout
        show={previewState?.show}
        handleClose={handleCancelPreview}
        title={previewState?.title || "Preview"}
        closeIcon={<span className="material-symbols-outlined">close</span>}
        propStyle={{ root: "pro-modal-xxl" }}
      >
        <div className="pro-p-4">
          {previewState?.blobUrl && (
            <iframe
              title="pdf-preview"
              src={`${previewState.blobUrl}#toolbar=0`}
              style={{
                width: "100%",
                height: "75vh",
                border: "1px solid var(--pro-outline-border)",
                borderRadius: 4,
              }}
            />
          )}
          <div className="pro-d-flex pro-justify-end pro-mt-4">
            <Button
              className={"pro-btn-link lg pro-px-5"}
              onClick={handleCancelPreview}
              type="button"
            >
              Cancel
            </Button>
            <Button
              className={"pro-btn-primary lg pro-ms-3"}
              onClick={handleConfirmPrint}
              type="button"
            >
              Print &amp; Upload
            </Button>
          </div>
        </div>
      </ModalLayout>
    </div>
  );
};

export default PrintingTable;
